import { GenericObject, ImportStatus, copyFields, fixDates } from '@synergy/models';

import { Contact } from '../../../../common/models/contact';
import { Supplier } from '../../../../common/models/supplier';
import { User } from '../../../../common/models/user';

export class ImportJob {
    public id!: number;
    public number!: string;
    public name!: string;
    public status!: ImportStatus;
    public responsibleContact!: Contact;
    public supplierAccount!: Supplier;
    public itemCount!: number;
    public publishedItemCount!: number;
    public failedItemCount!: number;
    public warningItemCount!: number;
    public processingFilesCount!: number;

    public createdAt!: Date;
    public createdBy?: User;
    public updatedAt?: Date;
    public updatedBy?: User;
    public publishDate?: Date;

    public static fromPlainObject(object: GenericObject): ImportJob {
        const job = new ImportJob();

        copyFields(object, job);

        if (object['responsibleContact']) {
            job.responsibleContact = Contact.fromPlainObject(object['responsibleContact']);
        }

        if (object['supplierAccount']) {
            job.supplierAccount = Supplier.fromPlainObject(object['supplierAccount']);
        }

        if (object['createdBy']) {
            job.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            job.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        fixDates(job, ['createdAt', 'updatedAt']);

        return job;
    }
}
